import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import { DashboardCardItem } from './components/DashboardCardItem';
import currencyFormatter from 'currency-formatter';
import { useMetaCloudHook } from '../meta-api-cloud/meta-api-cloud-hooks';
import { useMetaApiCloudMetricsLazyQuery } from '../../shared/types/generated';
import { useAuth } from '../auth/auth-hooks';

type DashboardProps = {
  number?: number;
};

export const Dashboard: React.FC<DashboardProps> = () => {
  const { connection } = useMetaCloudHook();
  const terminalState = connection?.terminalState;
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const [callMetrics, { data }] = useMetaApiCloudMetricsLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });


  useEffect(() => {
    if (user) {

      callMetrics({
        variables: {
          where: {
            user_id: user.id,
          },
        },
      });

      setInterval(() => {
        callMetrics({
          variables: {
            where: {
              user_id: user.id,
            },
          },
        });
      }, 5000);
    }


  }, [callMetrics, user]);


  const metrics = data?.metaApiCloudMetrics;

  const balance = currencyFormatter.format(terminalState?.accountInformation.balance as number, {
    code: terminalState?.accountInformation?.currency,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box display='flex' alignItems='center'>
          <HomeIcon fontSize='medium' /> Dashboard
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography>Here are some insights on your account</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='ACCOUNT BALANCE'
              content={balance}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='TODAY CURRENT PROFIT'
              content={metrics?.profit || 0}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='ACCOUNT MARGIN LEVEL (%)'
              content={(terminalState?.accountInformation.marginLevel || 0).toFixed(2)}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='CURRENT OPEN TRADES'
              content={connection?.terminalState.positions.length || 0}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='TODAY MOST PROFITABLE PAIR'
              content={(metrics?.best_pair as { currency: string })?.currency || '-'}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='TODAY TOTAL TRADES'
              content={(metrics?.trades_close_in_profit || 0) + (metrics?.trades_close_in_lose || 0)}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='TODAY TRADES CLOSED IN PROFIT'
              content={(metrics?.trades_close_in_profit || 0)}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DashboardCardItem
              title='TODAY TRADES CLOSED IN LOSS'
              content={(metrics?.trades_close_in_lose || 0)}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
